import { jsx } from 'react/jsx-runtime';

const SvgMiscHandFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M3 14.84h.02c.11 1.78.77 3.5 1.89 4.89A8.636 8.636 0 0 0 11.7 23H15c3.31 0 6-2.69 6-6V7h-2v4.81l-2-.35V3h-2v8.1l-2-.35V1h-2v9.4l-2-.35V2H7v11.51l-2-.35V10H3v4.84Z" }) }));

export { SvgMiscHandFill as default };
//# sourceMappingURL=MiscHandFill.es.js.map
